import { type IconProps } from '@atlaskit/icon';
import { Inline, Stack, Text, Box, xcss } from '@atlaskit/primitives';
import React, { type FunctionComponent } from 'react';

const iconStyles = xcss({
  alignItems: 'center',
  display: 'flex'
});

const menuIconStyles = xcss({
  paddingTop: 'space.025'
});

export interface ParentPickerOptionProps {
  IconComponent: React.ComponentType<IconProps>;
  valueName: string;
  spaceName: string;
  context: 'menu' | 'value';
  isSelected?: boolean;
}

const ParentPickerOption: FunctionComponent<ParentPickerOptionProps> = ({
  IconComponent,
  valueName,
  spaceName,
  context,
  isSelected
}) => {
  return (
    <Inline
      space="space.100"
      alignBlock={context === 'value' ? 'center' : 'start'}
      xcss={
        context === 'value' &&
        xcss({
          textWrap: 'wrap'
        })
      }
    >
      <Box xcss={[iconStyles, context === 'menu' && menuIconStyles]}>
        <IconComponent label="" size="medium" />
      </Box>
      <Stack space="space.025">
        <Text maxLines={context === 'value' ? 1 : undefined} color="inherit">
          {valueName}
        </Text>
        {context === 'menu' && (
          <Text color={isSelected ? 'inherit' : 'color.text.subtlest'}>{spaceName}</Text>
        )}
      </Stack>
    </Inline>
  );
};

export default ParentPickerOption;
